import {keyMirror} from 'utils/DBUtils';

export const Types = keyMirror({
  REQUEST_WINNERS: null,
  REQUESTED_WINNERS: null,
  RECEIVED_WINNERS: null,
  EXPAND_ROW: null,
  COLLAPSE_ROW: null,

  OPEN_EDIT_WINNER_STORY_MODAL: null,
  CLOSE_EDIT_WINNER_STORY_MODAL: null,
  EDIT_WINNER_STORY_ERROR: null,
  SAVE_WINNER_STORY: null,

  SUBMIT_SAVE_DATE_ORDERED: null,
  SAVE_DATE_ORDERED_SUCCESS: null,
  SAVE_DATE_ORDERED_ERROR: null,

  START_EDIT_NOTES: null,
  END_EDIT_NOTES: null,
  SAVE_NOTES: null,
  SUBMIT_SAVE_NOTES: null,
  SAVE_NOTES_SUCCESS: null,
  SAVE_NOTES_ERROR: null,

  SUBMIT_TOGGLE_FEATURED_WINNER: null,
  TOGGLE_FEATURED_WINNER_SUCCESS: null,
  TOGGLE_FEATURED_WINNER_ERROR: null,
  OPEN_FEATURED_ERROR_MODAL: null,
  CLOSE_FEATURED_ERROR_MODAL: null,

  SUBMIT_PUBLISH_FEATURED_WINNERS: null,
  PUBLISH_FEATURED_WINNERS_SUCCESS: null,
  PUBLISH_FEATURED_WINNERS_ERROR: null,
  OPEN_PUBLISH_FEATURED_ERROR_MODAL: null,
  CLOSE_PUBLISH_FEATURED_ERROR_MODAL: null
});


/* list winners */

export const requestWinnersAction = (prizeType, defaultSort) => ({
  type: Types.REQUEST_WINNERS,
  prizeType,
  defaultSort
});

export const requestedWinnersAction = prizeType => ({
  type: Types.REQUESTED_WINNERS,
  prizeType
});

export const receivedWinnersAction = () => ({
  type: Types.RECEIVED_WINNERS
});

export const expandRow = row => ({
  type: Types.EXPAND_ROW,
  row
});

export const collapseRow = () => ({
  type: Types.COLLAPSE_ROW
});


/* edit winner story */

export const openEditWinnerStoryModalAction = winnerId => ({
  type: Types.OPEN_EDIT_WINNER_STORY_MODAL,
  winnerId
});

export const closeEditWinnerStoryModalAction = () => ({
  type: Types.CLOSE_EDIT_WINNER_STORY_MODAL
});

export const editWinnerStoryErrorAction = () => ({
  type: Types.EDIT_WINNER_STORY_ERROR
});

export const saveWinnerStoryAction = winnerStoryWithEdits => ({
  type: Types.SAVE_WINNER_STORY,
  winnerStoryWithEdits
});

export const saveNotesAction = notes => ({
  type: Types.SAVE_NOTES,
  notes
});

export const saveWinnerNotesSuccessAction = (winnerId) => ({
  type: Types.SAVE_NOTES_SUCCESS,
  winnerId
});

export const saveWinnerNotesErrorAction = (winnerId) => ({
  type: Types.SAVE_NOTES_ERROR,
  winnerId
});

export const endEditNotesAction = () => ({
  type: Types.END_EDIT_NOTES
});

export const startEditNotesAction = (winnerId) => ({
  type: Types.START_EDIT_NOTES,
  winnerId
});

/* date ordered input */

export const submitSaveDateOrderedAction = (winnerId, dateOrdered) => ({
  type: Types.SUBMIT_SAVE_DATE_ORDERED,
  winnerId,
  dateOrdered
});

export const saveDateOrderedSuccessAction = winnerId => ({
  type: Types.SAVE_DATE_ORDERED_SUCCESS,
  winnerId
});

export const saveDateOrderedErrorAction = winnerId => ({
  type: Types.SAVE_DATE_ORDERED_ERROR,
  winnerId
});


/* toggle featured winner */

export const submitToggleFeaturedWinnerAction = winnerId => ({
  type: Types.SUBMIT_TOGGLE_FEATURED_WINNER,
  winnerId
});

export const toggleFeaturedWinnerSuccessAction = winnerId => ({
  type: Types.TOGGLE_FEATURED_WINNER_SUCCESS,
  winnerId
});

export const toggleFeaturedWinnerErrorAction = winnerId => ({
  type: Types.TOGGLE_FEATURED_WINNER_ERROR,
  winnerId
});

export const openFeaturedErrorModalAction = lang => ({
  type: Types.OPEN_FEATURED_ERROR_MODAL,
  lang
});

export const closeFeaturedErrorModalAction = () => ({
  type: Types.CLOSE_FEATURED_ERROR_MODAL
});


/* publish featured winners */

export const submitPublishFeaturedAction = lang => ({
  type: Types.SUBMIT_PUBLISH_FEATURED_WINNERS,
  lang
});

export const publishFeaturedSuccessAction = () => ({
  type: Types.PUBLISH_FEATURED_WINNERS_SUCCESS
});

export const publishFeaturedErrorAction = () => ({
  type: Types.PUBLISH_FEATURED_WINNERS_ERROR
});

export const openPublishErrorModalAction = () => ({
  type: Types.OPEN_PUBLISH_FEATURED_ERROR_MODAL
});

export const closePublishErrorModalAction = () => ({
  type: Types.CLOSE_PUBLISH_FEATURED_ERROR_MODAL
});



// WEBPACK FOOTER //
// ./public/pages/ListWinners/actions.js